export {checkWinScore} from './check-win-score'